export default __webpack_public_path__ + "assets/json/drone-left.f23e65.json";